import Vue from 'vue'

import Vuex from 'vuex'

import i18n from '@src/plugins/i18n'
import router from '@src/router'

import modules from './modules'

Vue.use(Vuex)
let moduleReset = ['client', 'user', 'role']
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {
    reset({ commit }) {
      moduleReset.forEach((key) => {
        commit(`${key}/reset`)
      })
    },
    gotoLogin({ rootState }) {
      if (rootState.route.requiresAuth) {
        router.push({
          name: 'login',
          query: {
            redirect: rootState.route.path,
          },
        })
      }
    },
    copyToClipboard({ dispatch }, str) {
      copyTextToClipboard(str)
      dispatch(
        'notify/success',
        {
          message: i18n.t('notify.success.copyToClipboard'),
        },
        {
          root: true,
        }
      )
    },
  },
  modules,
})
function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    console.info('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(
    function() {
      console.info('Async: Copying to clipboard was successful!')
    },
    function(err) {
      console.error('Async: Could not copy text: ', err)
    }
  )
}
